<template>
    <div class="live-list">
        <video-list-skeleton v-if="loading"></video-list-skeleton>

        <div class="live-list-container" v-else>
            <div class="header-search">
                <van-search
                    shape="round"
                    v-model="value"
                    @click="goSearch()"
                    @search="onSearch"
                    @clear="onCancel"
                    placeholder="搜一搜"
                    background="transparent"
                ></van-search>
            </div>

            <div class="swipe">
                <van-swipe :autoplay="3000" indicator-color="#fff">
                    <van-swipe-item v-for="(item, i) in banners" :key="i">
                        <a
                            :href="
                                item.target_url.replace(
                                    'https://care-yyh.com',
                                    'https://care-yyh.com'
                                )
                            "
                        >
                            <img :src="item.img" alt="" />
                        </a>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="activity-enter">
                <div class="activity-enter-wrap">
                    <div class="activity-enter-wrap-left">
                        <span>近期活动</span>
                        <span>更多精彩活动推荐</span>
                    </div>
                    <div class="activity-enter-wrap-right">
                        <span @click="$router.push('/activity-list')">立即前往</span>
                    </div>
                </div>
            </div>
            <div class="live-line" style="margin-top: 20px;"></div>

            <div style="margin-top: 20px" v-if="forecast && forecast != null && forecast.length > 0">
                <div class="live-list-section-title"><span> </span>直播中·预告</div>
                <div class="live-list-section">
                    <van-row @click="go_detail(item)" v-for="item in forecast" :key="item.id">
                        <div class="live-list-section-box">
                            <div class="live-list-section-left">
                                <van-image
                                    class="live-list-section-left-img"
                                    fit="cover"
                                    :src="item.cover_img_s == '' ? item.cover_img : item.cover_img_s"
                                />
                                <div v-if="item.live_status == 0" class="live-list-section-left-zl">直播预告</div>
                                <div v-else-if="item.live_status == 1" class="live-list-section-left-zl current">
                                    <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> 直播中
                                </div>
                            </div>
                            <div class="live-list-section-right">
                                <div class="live-list-section-right-title">{{ item.title }}</div>
                                <div class="live-list-section-right-detail">
                                    <div class="live-list-section-right-detail-time">
                                        {{ item.start_at }}
                                    </div>
                                    <span class="live-list-section-right-detail-join">
                                        {{ item.live_status === 0 ? (item.isAppointment ? '已预约' : '预约') : '加入' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </van-row>
                </div>
                <div class="live-line"></div>
            </div>

            <div class="live-column-section" style="background: #F7F7F8" v-if="column && column.length > 0">
                <div class="column-section-title">
                    <i> </i>精选直播<span @click="$router.push({ name: 'live-column-list' })"
                        >查看更多<img src="/static/img/icon_more.svg" alt=""
                    /></span>
                </div>
                <div v-swiper:mySwiper="swiperOption" ref="liveSwipe" style="margin-top: 15px">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide column-section-swiper"
                            v-for="item in column"
                            :key="item.id"
                            @click="$router.push({ name: 'live-column', params: { id: item.id } })"
                        >
                            <img class="column-section-swiper-image" width="100%" :src="item.cover_img" alt="" />
                            <div class="column-section-content">
                                <div class="column-section-content-title">{{ item.title }}</div>
                                <div class="column-section-content-detail">已开展{{ item.current_count }}期</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="live-line"></div>

            <div class="live-list-section-title" style="margin-top: 22px">精彩回放<span> </span></div>

            <div class="tags">
                <van-tabs :swipeable="true" v-model="category_index" @click="chooseCategory">
                    <van-tab v-for="item in live_types" :key="item.id" :title="item.title"></van-tab>
                </van-tabs>
                <div class="clear"></div>
            </div>

            <div class="live-list-section" style="margin-top: 22px">
                <van-row @click="go_detail(item)" v-for="item in backs" :key="item.id">
                    <div class="live-list-section-box">
                        <div class="live-list-section-left">
                            <van-image
                                class="live-list-section-left-img"
                                fit="contain"
                                :src="item.cover_img_s == '' ? item.cover_img : item.cover_img_s"
                            />
                            <div class="live-list-section-left-zl">直播回放</div>
                            <div class="live-list-section-left-time">
                                <span>{{ item.duration_format }}</span>
                            </div>
                        </div>
                        <div class="live-list-section-right">
                            <div class="live-list-section-right-title">{{ item.title }}</div>
                            <div class="live-list-section-right-detail">{{ item.view_count }}人观看</div>
                        </div>
                    </div>
                </van-row>
            </div>
            <div class="van-list__finished-text" v-if="backs.length > 0 && page === total_page">已到底部</div>
            <div v-else-if="backs.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">
                查看更多
            </div>
            <!-- 菜单栏 -->
            <van-tabbar
                class="home-footer"
                :fixed="true"
                :safe-area-inset-bottom="true"
                v-model="tabbarActive"
                active-color="#0FB7AD"
            >
                <van-tabbar-item icon="/static/bytx/home/tab_1_icon.svg" @click="$toHomePage">首页</van-tabbar-item>
                <van-tabbar-item icon="/static/bytx/home/tab_2_selected_icon.svg" :to="'live-list'"
                    >看直播</van-tabbar-item
                >
                <van-tabbar-item icon="/static/bytx/home/tab_3_icon.svg" :to="'comrade-list'">交流社区</van-tabbar-item>
                <van-tabbar-item icon="/static/bytx/home/tab_4_icon.svg" :to="'my'">我的</van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import videoListSkeleton from '@/skeleton/videoListSkeleton'
export default {
    name: 'live-list',
    components: {
        'video-list-skeleton': videoListSkeleton
    },
    data() {
        return {
            tabbarActive: 1,
            value: '',
            active: '',
            category_id: 0,
            category_index: 0,
            category_child_id: 0,
            banners: [],
            live_types: [
                { id: '1', title: '科普患教' },
                { id: '2', title: '公益活动' },
                { id: '3', title: '战友故事' },
                { id: '4', title: '心理健康' }
            ],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            forecast: [],
            backs: [],
            loading: true,
            page: 1,
            pageSize: 10,
            total_page: 1,
            swiperOption: {
                width: 156,
                height: 190,
                spaceBetween: 15
            },
            record_id: 0
            // load: false
        }
    },
    activated() {
        console.log(123)
        this.fetch('banner')
        this.fetch('homepage')
        this.chooseCategory()
        sessionStorage.removeItem('search_data')
    },
    methods: {
        onSearch() {
            this.fetch('reBack')
            this.fetch('homepage')
        },
        onCancel() {
            this.value = ''
            this.fetch('reBack')
            this.fetch('homepage')
        },
        fetch(scene) {
            if (scene === 'homepage') {
                let params = {
                    pageSize: 999
                }
                if (this.value != '') {
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.home, params).then(res => {
                    console.log(res, 'res')
                    if (res.data.recommend) {
                        this.column = res.data.recommend
                    } else {
                        this.column = []
                    }
                    if (res.data.banners) {
                        this.banners = res.data.banners
                    } else {
                        this.banners = []
                    }
                    if (res.data.forecast) {
                        this.forecast = res.data.forecast
                    } else {
                        this.forecast = []
                    }
                    Interface.getShareInfo(this, '看直播——博医同行', '', '数万病友都在看')
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            } else if (scene === 'reBack') {
                this.page = 1
                let params = {
                    page: this.page,
                    pageSize: this.pageSize,
                    live_type: this.category_id
                }
                if (this.value != '') {
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.reBack, params).then(res => {
                    if (res.data.list != null) {
                        this.backs = res.data.list
                        this.total_page = res.data.total_page
                    } else {
                        this.backs = []
                        this.total_page = 1
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            }
        },
        fetch_more() {
            this.page += 1
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                live_type: this.category_id
            }
            Interface.getData('get', Interface.live.reBack, params).then(res => {
                this.backs.push(...res.data.list)
                this.total_page = res.data.total_page
            })
        },
        go_detail(item) {
            if (item.live_status === 6) {
                Interface.goLive(this, item.id,item.type, item.live_status)
                Interface.mFootPrint(item.id,4,3,2,0,0,0,item.title)
                sessionStorage.setItem('pageType',2)
            } else {
                if (item.live_status === 0) {
                    Interface.goLive(this, item.id,item.type, item.live_status)
                } else {
                    Interface.goLive(this, item.id,item.type, item.live_status)
                    sessionStorage.setItem('pageType',2)
                }
            }
        },
        chooseCategory() {
            this.category_id = this.live_types[this.category_index].id
            this.page = 1
            this.pageSize = 10
            this.fetch('reBack')
        },
        goSearch() {
          this.$router.push({ name: 'search', query: { pageType: 2 } })
          Interface.mFootPrint(0,76,0,2,0,0,0,'直播-搜索')
        }
    },
    created() {
        this.fetch('banner')
        this.fetch('homepage')
        Interface.getData('post',Interface.footprint, {
          id: 1,
          type: 107,
          content_type: 0,
          page_type: 2,
          source_type: 0,
          parent_id: 0,
          record_id: 0,
          title: '看直播tab页'
        }).then( (res) => {
          if (res.code == 0) {
            this.record_id = res.data.record_id
          }
        })
        this.chooseCategory()
        Interface.CoFootPrint(7)
        sessionStorage.removeItem('search_data')
    },
    beforeRouteLeave(to, from, next) {
      if (this.record_id) {
        Interface.mFootPrint(1, 107,0, 2, 0, 0,this.record_id,'看直播tab页')
      }
      next()
    }
}
</script>
<style lang="scss">
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/live/list/index.vue